import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import ApiContext from "src/provider/API/call-service"
import { Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { TxPinVerification } from "src/component"

export const HotlistCard: React.FC<any> = ({card, updateCardList, close}) => {
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({reason: '', otherReason: '', pin: ''})
    const [view, setView] = useState('hotlist-card')

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('pin')
    }

    async function handleSubmit() {
        const response = await API.hotlistCard({
            ...input, 
            accountNumber: card?.accountNumber, 
            pan: card?.cardPAN, 
            serialNo: card.serialNo,
            reason: input.otherReason || input.reason
        })
        if (response) updateCardList()
        close()
    }

    return (
        <>
            { view === 'hotlist-card' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Hotlist Card</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <Form onSubmit={handleProceed}>
                            <FormGroupWithIcon>
                                <label>Reason</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Reason"
                                        name='reason'
                                        value={input.reason}
                                        style={{color: input.reason ? '#000000' : '#667085'}}
                                        onChange={(e) => setInput({...input, reason: e.target.value, otherReason: ''})}
                                        required
                                    >
                                        <option value="">Select Reason</option>
                                        <option value="I lost my card">I lost my card</option>
                                        <option value="My card was stolen">My card was stolen</option>
                                        <option value="Others">Others</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            { input.reason === 'Others' &&
                                <FormGroup>
                                    <label>Other Reason</label>
                                    <textarea 
                                        placeholder='Enter a reason' 
                                        name='otherReason'
                                        value={input.otherReason}
                                        onChange={(e) => setInput({...input, otherReason: e.target.value})}
                                        //required
                                    />
                                </FormGroup>
                            }
                            <FlexRow justifyContent='flex-end' topMargin='2.5'>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={close}
                    onPinChange={(pin: string) => setInput({...input, pin})}
                    next={handleSubmit} 
                />
            }
        </>
    )
}